module.exports = __webpack_public_path__ + "img/unknown.26df3c51.jpg";